import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <footer>
      <p className="copyright">
        Inspired by <a className="copi" href="https://github.com/jigalin" target="_blank">Matthew Jigalin</a>
      </p>
    </footer>
  )
}

export default Footer
